type PaddingProps = {
  children?: React.ReactNode;
};

const Padding = (props: PaddingProps) => {
  return <div className="padding">{props.children}</div>;
};
export default Padding;
